module.exports = ".container{\r\n    margin-top: 100px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/latestnews/latestnews.component.css
// module id = ./src/app/pages/latestnews/latestnews.component.css
// module chunks = main